import { forwardRef, } from 'react';
export const forwardRefWithName = (render) => {
    const component = forwardRef(render);
    component.displayName = render.name.replace(/^(\w+)Component$/, '$1');
    return component;
};
//# sourceMappingURL=forwardRefWithName.js.map